export default __webpack_public_path__ + "static/media/photo.75e38841.png";